const _usdFmt = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
const _uzsFmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 })

export function formatMoney(amount: number): string {
  return `$${_usdFmt.format(amount)}`
}

export function formatMoneyHint(amount: number, rate: number): string {
  return `≈ ${_uzsFmt.format(Math.round(amount * rate))} сум`
}

const TZ = 'Asia/Tashkent'  // UTC+5

// FastAPI serializes naive datetimes without 'Z', so browsers parse them as
// local time instead of UTC. We append 'Z' to force correct UTC interpretation.
function parseUTC(iso: string): Date {
  return new Date(/[Z+]/.test(iso) ? iso : iso + 'Z')
}

export function formatDate(iso: string | undefined | null): string {
  if (!iso) return '—'
  return parseUTC(iso).toLocaleDateString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    timeZone: TZ,
  })
}

export function formatDateTime(iso: string | undefined | null): string {
  if (!iso) return '—'
  return parseUTC(iso).toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
    timeZone: TZ,
  })
}

export function formatPercent(n: number): string {
  return `${n}%`
}

const ORDER_STATUS_LABELS: Record<string, { ru: string; uz: string; color: string }> = {
  awaiting_client_confirmation: { ru: 'Ждёт подтверждения клиента', uz: 'Mijoz tasdig\'ini kutmoqda', color: 'bg-yellow-900/30 text-yellow-300' },
  pending:   { ru: 'На рассмотрении', uz: "Ko'rib chiqilmoqda", color: 'bg-tg-bg2 text-tg-text2' },
  reviewing: { ru: 'Проверяется',     uz: 'Tekshirilmoqda',     color: 'bg-blue-900/30 text-blue-300' },
  approved:  { ru: 'Одобрено',        uz: 'Tasdiqlandi',        color: 'bg-tg-success-soft text-tg-success' },
  active:    { ru: 'Активна',         uz: 'Faol',               color: 'bg-tg-success-soft text-tg-success' },
  closed:    { ru: 'Закрыта',         uz: 'Yopildi',            color: 'bg-tg-bg2 text-tg-hint' },
  rejected:  { ru: 'Отклонено',       uz: 'Rad etildi',         color: 'bg-tg-danger-soft text-tg-danger' },
  cancelled: { ru: 'Отменено',        uz: 'Bekor qilindi',      color: 'bg-gray-800/60 text-gray-400' },
}

const PAYMENT_STATUS_LABELS: Record<string, { ru: string; uz: string; color: string }> = {
  pending:               { ru: 'Ожидает',          uz: 'Kutilmoqda',       color: 'bg-tg-bg2 text-tg-text2' },
  awaiting_confirmation: { ru: 'На подтверждении', uz: 'Tasdiqlanmoqda',   color: 'bg-tg-accent-soft text-tg-accent' },
  paid:                  { ru: 'Оплачен',           uz: "To'langan",        color: 'bg-tg-success-soft text-tg-success' },
  overdue:               { ru: 'Просрочен',         uz: "Muddati o'tgan",   color: 'bg-tg-danger-soft text-tg-danger' },
  partially_paid:        { ru: 'Частично',          uz: "Qisman to'langan", color: 'bg-yellow-900/30 text-yellow-300' },
}

export function orderStatusLabel(status: string, lang: 'ru' | 'uz' = 'ru') {
  return ORDER_STATUS_LABELS[status]?.[lang] ?? status
}
export function orderStatusColor(status: string) {
  return ORDER_STATUS_LABELS[status]?.color ?? 'bg-tg-bg2 text-tg-text2'
}
export function paymentStatusLabel(status: string, lang: 'ru' | 'uz' = 'ru') {
  return PAYMENT_STATUS_LABELS[status]?.[lang] ?? status
}
export function paymentStatusColor(status: string) {
  return PAYMENT_STATUS_LABELS[status]?.color ?? 'bg-tg-bg2 text-tg-text2'
}
